<div [hidden]="!viewCondition" class="target-container">
    <div class="target-card">
        <h2>{{ title }}</h2>

        <svg class="target-svg" viewBox="0 0 1000 1000" preserveAspectRatio="xMidYMid meet">
            <g [attr.transform]="targetScaleTransform">
                @for (ring of rings; track ring) {
                    <circle
                        [attr.cx]="centerX"
                        [attr.cy]="centerY"
                        [attr.r]="ring * ringWidth * scaleFactor"
                        stroke-width="2"
                        [attr.fill]="ring <= 5 ? 'black' : 'white'"
                        [attr.stroke]="ring <= 5 ? 'white' : 'black'"
                    />
                }
                <circle
                    [attr.cx]="centerX"
                    [attr.cy]="centerY"
                    [attr.r]="(ringWidth * scaleFactor) / 2"
                    fill="none"
                    stroke="white"
                    stroke-width="2"
                    stroke-dasharray="8 6"
                />
            </g>

            <g [attr.transform]="targetScaleTransform">
                @for (label of labels; track $index) {
                    <rect
                        [attr.x]="getLabelRectX(label.position)"
                        [attr.y]="getLabelRectY(label.position)"
                        width="24"
                        height="20"
                        [attr.fill]="label.backgroundColor"
                    />
                    <text
                        [attr.x]="label.position.x"
                        [attr.y]="label.position.y"
                        [attr.fill]="label.textColor"
                        text-anchor="middle"
                        dominant-baseline="central"
                        class="label-text"
                    >{{ label.ringNumber }}</text>
                }
            </g>

            <g [attr.transform]="targetScaleTransform">
                @for (shot of shots; track shot.id) {
                    <circle
                        class="animate-shot"
                        [attr.cx]="getShotSvgX(shot)"
                        [attr.cy]="getShotSvgY(shot)"
                        [attr.r]="shotRadius"
                        fill="red"
                        stroke="red"
                        stroke-width="2"
                        [attr.opacity]="shot.opacity"
                    />
                    <text
                        [attr.x]="getShotSvgX(shot)"
                        [attr.y]="getShotSvgY(shot)"
                        class="shot-number"
                    >{{ shot.displayIndex }}</text>
                }
            </g>
        </svg>

        @if (showControls) {
            <div class="target-controls">
                <input type="number" [(ngModel)]="shotX" placeholder="X">
                <input type="number" [(ngModel)]="shotY" placeholder="Y">
                <button mat-raised-button color="primary" type="button" (click)="addNewShot()">Schuss hinzufuegen</button>
                <button mat-stroked-button type="button" (click)="clearShots()">Loeschen</button>
            </div>
        }

        <p class="target-info"><small>{{ infoText }}</small></p>
    </div>
</div>